


import { useState, useRef, useEffect } from "react";

const GOOGLE_FORM_URL =


  "https://docs.google.com/forms/d/e/1FAIpQLSfTEgrR-ecVLF2Si_5Tn3xEM1v0gZq28ebK_XbKySPuIEl7JQ/formResponse";
const ENTRY_IDS = {

  type: "entry.1706311705",
  department: "entry.369643082",
  regNo: "entry.990403914",
  contact: "entry.590300132",
  details: "entry.1723200879",



       // TODO: replace with actual entry ID from your Google Form
};

const FEEDBACK_TYPES = ["Suggestion", "Compliment", "Complaint"];

const DEPARTMENTS = [
  "Actuarial Science",
  "Audit",
  "Business Management",
  "CODEL",
  "CPRS",
  "Catering",
  "Chemical Engineering",
  "Chemistry",
  "Civil Engineering",
  "Computer Science and IT",
  "Corporate Planning",
  "Counselling",
  "Courier Services",
  "DESIC",
  "DVC Administration & Finance",
  "DeKUT Enterprises (DEKUTES)",
  "Dean of Students Welfare (DSW)",
  "E-Learning",
  "Electrical Engineering",
  "Engineering",
  "Estates",
  "Examinations",
  "Faculty of Science",
  "Farm",
  "Film App",
  "Finance",
  "Financial Aid",
  "Geothermal Institute (GeTRI)",
  "Housekeeping",
  "Human Resource",
  "ICFOSS",
  "ICT",
  "IFBT",
  "IGGReS",
  "IGS",
  "ITOHM",
  "ITPS",
  "Information Technology (IT)",
  "Institute of Criminology, Forensics and Security Studies",
  "Institutional Advancement",
  "Internal Audit",
  "International Office",
  "Legal",
  "Library",
  "MPS",
  "Maintenance",
  "Marketing",
  "Mathematics and Physical Sciences",
  "Mechanical Engineering",
  "Mechatronic Engineering",
  "Medical",
  "Nursing",
  "Operations and Supply Chain Management",
  "Planning",
  "Procurement",
  "Public Relations",
  "Quality Assurance",
  "RIMCL",
  "Registrar's Office",
  "SBME",
  "SGSR",
  "School of Business (SOB)",
  "School of Engineering",
  "School of Science",
  "Security",
  "Siemens Centre",
  "Software Development Center (SDC)",
  "Sports and Games",
  "Students Welfare",
  "Technology Education",
  "Tourism",
  "Transport",
  "Vice Chancellor's Office",
];

const inputStyle = {
  width: "100%",
  padding: "1.6ch",
  borderRadius: "1.5ch",
  marginBottom: "10px",
  border: "1px solid #ccc",
  boxSizing: "border-box",
  fontSize: "14px",
  display: "block",
};

const selectStyle = { ...inputStyle };

// Type-to-filter combobox for Department
function DepartmentCombobox({ value, onSelect }) {
  const [query, setQuery] = useState(value || "");
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    setQuery(value || "");
  }, [value]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const filtered = DEPARTMENTS.filter((d) =>
    d.toLowerCase().includes(query.toLowerCase())
  );

  const handleInputChange = (e) => {
    const val = e.target.value;
    setQuery(val);
    setIsOpen(true);
    onSelect(""); // clear confirmed selection while typing
  };

  const handlePick = (dept) => {
    setQuery(dept);
    onSelect(dept);
    setIsOpen(false);
  };

  return (
    <div ref={wrapperRef} style={{ position: "relative", marginBottom: "10px" }}>
      <input
        type="text"
        placeholder="Type to search department..."
        value={query}
        onChange={handleInputChange}
        onFocus={() => setIsOpen(true)}
        style={{ ...inputStyle, marginBottom: 0, color: "#222222", backgroundColor: "#ffffff" }}
        autoComplete="off"
      />
      {isOpen && (
        <div
          style={{
            position: "absolute",
            top: "calc(100% + 4px)",
            left: 0,
            right: 0,
            background: "#ffffff",
            border: "1px solid #ccc",
            borderRadius: "1ch",
            maxHeight: "220px",
            overflowY: "auto",
            zIndex: 1000,
            boxShadow: "0 6px 16px rgba(0,0,0,0.12)",
            color: "#222222",
          }}
        >
          {filtered.length > 0 ? (
            <ul style={{ listStyle: "none", margin: 0, padding: "4px 0", color: "#222222" }}>
              {filtered.map((dept) => (
                <li
                  key={dept}
                  onClick={() => handlePick(dept)}
                  onMouseDown={(e) => e.preventDefault()}
                  style={{
                    padding: "1ch 1.6ch",
                    cursor: "pointer",
                    color: "#222222",
                    backgroundColor: "#ffffff",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f2f2f2")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#ffffff")}
                >
                  {dept}
                </li>
              ))}
            </ul>
          ) : (
            <div style={{ padding: "1ch 1.6ch", color: "#888888", backgroundColor: "#ffffff" }}>
              No matches found
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default function FeedbackForm() {
  const [formData, setFormData] = useState({
    type: "",
    contact: "",
    details: "",
    department: "",
    regNo: "",
  });

  const [status, setStatus] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleDepartmentSelect = (dept) => {
    setFormData((prev) => ({ ...prev, department: dept }));
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    return emailRegex.test(email.trim());
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setStatus("");
    setErrorMessage("");

    if (!formData.type) {
      setStatus("error");
      setErrorMessage("Please select a feedback type.");
      return;
    }

    if (!formData.department) {
      setStatus("error");
      setErrorMessage("Please select a valid department from the list.");
      return;
    }


    if (!isValidEmail(formData.contact)) {
      setStatus("error");
      setErrorMessage("Please enter a valid email address.");
      return;
    }

    if (!formData.details.trim()) {
      setStatus("error");
      setErrorMessage("Please provide the details of your feedback.");
      return;
    }

    setStatus("sending");

    const payload = new URLSearchParams({
      [ENTRY_IDS.type]: formData.type,
      [ENTRY_IDS.contact]: formData.contact,
      [ENTRY_IDS.details]: formData.details,
      [ENTRY_IDS.department]: formData.department,
      [ENTRY_IDS.regNo]: formData.regNo,
    });

    try {
      await fetch(GOOGLE_FORM_URL, {
        method: "POST",
        mode: "no-cors",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload,
      });

      setStatus("success");

      setFormData({
        type: "",
        contact: "",
        details: "",
        department: "",
        regNo: "",
      });

      setTimeout(() => setStatus(""), 5000);
    } catch (error) {
      console.error("Submission failed:", error);
      setStatus("error");
      setErrorMessage("Something went wrong while submitting.");
    }
  };

  return (
    <div className="form-content" style={{ maxWidth: 480, margin: "0 auto", padding: "24px", fontFamily: "sans-serif" }}>
      <h2>Submit Your Feedback</h2>
      <p>Suggestions/Enquiries, Complements or Complaints. Your feedback helps us improve our services. </p>

      <form onSubmit={handleSubmit} noValidate>
        <label htmlFor="type">Feedback Type *</label>
        <select
          id="type"
          name="type"
          value={formData.type}
          onChange={handleChange}
          style={selectStyle}
        >
          <option value="">-- Select --</option>
          {FEEDBACK_TYPES.map((type) => (
            <option key={type} value={type}>
              {type}
            </option>
          ))}
        </select>

        <label htmlFor="department">Department *</label>
        <DepartmentCombobox
          value={formData.department}
          onSelect={handleDepartmentSelect}
        />

        <label htmlFor="regNo">PF/Reg. No</label>
        <input
          id="regNo"
          type="text"
          name="regNo"
          value={formData.regNo}
          onChange={handleChange}
          placeholder="Optional"
          style={inputStyle}
        />

        <label htmlFor="contact"> Your Email *</label>
        <input
          id="contact"
          type="email"
          name="contact"
          value={formData.contact}
          onChange={handleChange}
          placeholder="you@example.com"
          style={inputStyle}
        />

        <label htmlFor="details">Details *</label>
        <textarea
          id="details"
          name="details"
          rows={5}
          value={formData.details}
          onChange={handleChange}
          placeholder="Describe your feedback..."
          style={inputStyle}
        />

        <button type="submit" disabled={status === "sending"} style={{  borderRadius: "3ch", cursor: "pointer" }}>
          {status === "sending" ? "Submitting..." : "SUBMIT"}
        </button>

        {status === "success" && (
          <p style={{ color: "green", fontWeight: "bold" }}>
            ✅ Feedback submitted successfully! Thank You.
          </p>
        )}

        {status === "error" && (
          <p style={{ color: "red", fontWeight: "bold" }}>{errorMessage}</p>
        )}
      </form>
    </div>
  );
}